import script from "./ModalBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalBox.vue?vue&type=script&setup=true&lang=js"

import "./ModalBox.vue?vue&type=style&index=0&id=642d66d3&scoped=true&lang=css"
import "./ModalBox.vue?vue&type=style&index=1&id=642d66d3&lang=css"
import "./ModalBox.vue?vue&type=style&index=2&id=642d66d3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-642d66d3"]])

export default __exports__